import { fetchJSON, POST, GET } from 'utils/http';
import {
    VALIDATE_COACH_FROM_DATABASE,
    GET_COACHES_APPLICATION,
    UPDATE_COACH_APPLICATION,
    SEARCH_USER_ATHLETE,
    UPGRADE_STUDENT,
    OVERRIDE_DIVISION,
    STUDENT_EVALUATION,
    ADD_COACH,
    DELETE_COACH,
    MODIFY_COLLEGE,
    GET_COACHES_FROM_COLLEGES,
    ADD_COLLEGE_TO_DB,
    GET_STUDENTS_FOR_STUDENT_EXPLORER,
    DELETE_COCAH_APPLICATION,
    RESET_STUDENT_DASHBOARD,
}
    from 'constants/urls';

export function searchUser(data, role) {
  let url = VALIDATE_COACH_FROM_DATABASE;
  if (role === 'STUDENT') {
    url = SEARCH_USER_ATHLETE;
  }
  return fetchJSON(url, POST, {}, data, {});
}

export function getCoachApplications(id) {
  return fetchJSON(GET_COACHES_APPLICATION + id, GET, {}, {}, {});
}

export function updateCoachApplication(payload) {
  return fetchJSON(UPDATE_COACH_APPLICATION, POST, {}, payload, {});
}

export function upgradeStudent(payload) {
  return fetchJSON(UPGRADE_STUDENT, POST, {}, payload, {});
}

export function overrideStudent(payload) {
  return fetchJSON(OVERRIDE_DIVISION, POST, {}, payload, {});
}

export function evaluateStudent(payload) {
  return fetchJSON(STUDENT_EVALUATION, POST, {}, payload, {});
}

export function deleteCoach(payload) {
  return fetchJSON(DELETE_COACH, POST, {}, payload, {});
}

export function addCoach(payload) {
  return fetchJSON(ADD_COACH, POST, {}, payload, {});
}

export function modifyCollege(payload) {
  return fetchJSON(MODIFY_COLLEGE, POST, {}, payload, {});
}

export function getCoachesFromColleges(id) {
  return fetchJSON(GET_COACHES_FROM_COLLEGES + id, GET, {}, {}, {});
}
export function addCollegeToDB(payload) {
  return fetchJSON(ADD_COLLEGE_TO_DB, POST, {}, payload, {});
}

export function getStudentForStudentExplorer(payload) {
  return fetchJSON(GET_STUDENTS_FOR_STUDENT_EXPLORER, POST, {}, payload, {});
}

export function deleteCoachApplication(id) {
  return fetchJSON(DELETE_COCAH_APPLICATION + id, GET, {}, {}, {});
}

export function resetStudentDashboard(id) {
  return fetchJSON(RESET_STUDENT_DASHBOARD + id, GET, {}, {}, {});
}



// WEBPACK FOOTER //
// ./src/common/services/admin.services/services.js